export default __webpack_public_path__ + "static/media/prod-page-ferragens.3e1330f7.jpg";